import { useLanguage } from '@hooks/useLanguage';
import { useMemo } from 'react';
import { getValidationSchemaVolunteerLegalPerson } from './constants';

export function useGetValidationSchemaVolunteerLegalPerson() {
  const language = useLanguage();

  return useMemo(() => getValidationSchemaVolunteerLegalPerson(language), [language]);
}
